import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      totalRules: [v => !!v || 'Field is required'],
      dateRules: [],
      externalRefRules: [v => !!v || 'Field is required'],
      xeroRefRules: [v => !!v || 'Field is required'],
      internalNotesRules: [
        //v => !!v || 'Field is required',
        v => Rules.maxLength(v, 500)
      ],
      invoiceNotesRules: [
        //v => !!v || 'Field is required',
        v => Rules.maxLength(v, 500)
      ]
    }
  }
}
